import { Card } from "antd"
import PropTypes from "prop-types"
import styles from "./ExperiencesPreview.module.css"

const IconCard = ({ icon, label, className }) => {
  return (
    <Card className={`${styles.iconCard} ${className ? styles[className] : ""}`}>
      <div className={styles.cardContent}>
        <div className={styles.iconWrapper}>{icon}</div>
        <div className={`${styles.label} ml-s`}>{label}</div>
      </div>
    </Card>
  )
}

// ✅ Add prop types
IconCard.propTypes = {
  icon: PropTypes.node.isRequired, // A React element (like an icon)
  label: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default IconCard
